<template>
  <div>
    <layout headerTitle="Sistema de vigilancia epidemiológico">
      <template #container>
        <b-row class="pt-4 pb-5">
          <div style="display: flex; left: 15px; margin-bottom: 10px">
            <label class="mr-2 breadcrumb-link"
              ><button
                class="mt-0 p-0 pb-1 d-flex align-items-center breadcrumb-link back"
                style="
                  border: none;
                  background-color: transparent;
                  font-size: 16px;
                "
                @click.prevent="back"
              >
                Volver atrás
              </button></label
            >
          </div>
          <b-col cols="12">
            <img
              alt="group"
              :src="require('@/assets/modules/health-tracker/icon/group.svg')"
            />
            <strong class="pl-2"
              >{{ nameForm }} diagnóstico - Detalle de la enfermedad</strong
            >
          </b-col>
        </b-row>

        <b-row class="mb-5">
          <b-col cols="12">
            <strong>Datos del trabajador</strong>
            <worker-information :id="employeeId" />
          </b-col>
        </b-row>
        <!-- opciones -->
        <FormCharacterization
          @changeForm="changeForm"
          :loading="loading"
          :isEdit="isEdit"
          :isBusy="isBusy"
          :record="record"
        />
        <FormDetailAnalysis
          @changeForm="changeForm"
          :entities="entities"
          :loading="loading"
          :isEdit="isEdit"
          :isBusy="isBusy"
          :record="record"
        />

        <hr class="hr-form-ipt" />
        <b-row class="mt-5" v-if="isValidation && !loading">
          <b-col cols="12">
            <b-alert show variant="danger" class="alert-danger-form-ipt">
              <div class="d-flex align-items-center">
                <div class="mr-3">
                  <img
                    src="@/assets/images/icons/icon-danger.svg"
                    alt=""
                    width="28px"
                    height="28px"
                  />
                </div>
                <p
                  style="
                    font-size: 16px;
                    color: #ac0000;
                    margin-bottom: 0;
                    font-weight: 400;
                  "
                >
                  Para guardar un diagnóstico es necesario llenar los campos y
                  documentos requeridos *.
                </p>
              </div>
            </b-alert>
          </b-col>
        </b-row>

        <div
          class="mt-5 d-flex justify-content-end mb-5"
          v-if="!loading && !isEdit"
        >
          <button
            class="button_primary"
            @click.prevent="saveDiagnostic"
            :disabled="isValidation || isBusy"
          >
            {{ !record ? "Registrar diagnóstico" : "Guardar cambios" }}
            <b-spinner v-if="isBusy" />
          </button>
        </div>
      </template>
    </layout>
    <!-- 3 MODAL PROCESO EXITOSO  -->
    <modal-success :messageModal="messageModal" />

    <!-- 4 MODAL PROCESO FALLIDO -->
    <modal-error :error="error" />
  </div>
</template>

<script>
import FormCharacterization from "./components/FormCharacterization.vue";
import FormDetailAnalysis from "./components/FormDetailAnalysis.vue";
import ModalSuccess from "@/views/SVE/modals/ModalSuccess.vue";
import ModalError from "@/views/SVE/modals/ModalError.vue";
import {
  getInfoSelect,
  saveDiagnostic,
  detailDiagnostic,
  editDiagnostic,
} from "@/services/health-tracker/diagnostic/service";

export default {
  name: "create",
  components: {
    layout: () => import("@/layouts/modules/health-tracker/v2/app.vue"),
    WorkerInformation: () =>
      import(
        "@/components/Modules/HealthTracker/V2/Common/WorkerInformation/WorkerInformation.vue"
      ),
    FormCharacterization,
    FormDetailAnalysis,
    ModalSuccess,
    ModalError,
  },
  data: () => ({
    is_active_class: 0,
    formData: {
      group_diagnostic: null,
      diagnostic: null,
      risk: null,
      laterality: null,
      applicant: null,
      start_date: "",
      request_date: "",
      delivery_date: "",
      work_analysis_file: null,
      apt_documentation_file: null,
      apt_request_file: null,
    },
    isBusy: false,
    entities: [],
    messageModal: "Diagnóstico guardado exitosamente",
    error: {
      message: "",
    },
    isEdit: false,
    loading: false,
    record: null,
  }),
  computed: {
    employeeId() {
      return parseInt(this.$route.params.employee_id || "0");
    },
    diagnosticId() {
      return parseInt(this.$route.params.diagnostic_id || "0");
    },
    isValidation() {
      const me = this;
      let isValidation = true;

      isValidation =
        me.formData.diagnostic?.id &&
        me.formData.risk?.id &&
        me.formData.laterality?.id
          ? false
          : true;

      return isValidation;
    },
    nameForm() {
      const me = this;
      let text = "Nuevo";
      if (me.diagnosticId > 0 && !me.isEdit) {
        text = "Editar";
      } else if (me.diagnosticId > 0 && me.isEdit) {
        text = "Detalle";
      }
      return text;
    },
  },
  methods: {
    changeForm(formData) {
      const me = this;
      me.formData = {
        ...me.formData,
        ...formData,
      };
    },
    async saveDiagnostic() {
      const me = this;
      me.isBusy = true;
      const formData = me.parseData();
      try {
        me.record ? await editDiagnostic(formData, me.diagnosticId) : await saveDiagnostic(formData);
        me.$bvModal.show("modal-success");
        setTimeout(() => {
          me.back();
        }, 5000);
      } catch (error) {
        me.error.message = "Error al guardar Formulario";
        me.$bvModal.show("modal-fail");
      } finally {
        me.isBusy = false;
      }
    },
    back() {
      const me = this;
      me.$router.push({
        name: "sve",
        params: {
          category: "diagnostics-register",
          type: me.employeeId,
        },
      });
    },
    parseData() {
      const me = this;
      const formData = new FormData();
      formData.append("employee", me.employeeId);
      formData.append("diagnostic", me.formData.diagnostic?.id || null);
      formData.append("risk", me.formData.risk?.id || null);
      formData.append("laterality", me.formData.laterality?.id || null);
      me.formData.applicant !== null &&
        formData.append("applicant", me.formData.applicant?.id || null);
      me.formData.start_date !== "" &&
        formData.append("start_date", me.formData.start_date);
      me.formData.request_date !== "" &&
        formData.append("request_date", me.formData.request_date);
      me.formData.delivery_date !== "" &&
        formData.append("delivery_date", me.formData.delivery_date);

      me.formData.work_analysis_file !== null &&
        formData.append(
          "files[work_analysis_file]",
          me.formData.work_analysis_file
        );
      me.formData.apt_documentation_file !== null &&
        formData.append(
          "files[apt_documentation_file]",
          me.formData.apt_documentation_file
        );
      me.formData.apt_request_file !== null &&
        formData.append(
          "files[apt_request_file]",
          me.formData.apt_request_file
        );

      return formData;
    },
    async loadEntities() {
      const me = this;
      me.entities = [];
      me.loading = true;
      try {
        const { data } = await getInfoSelect("responsible_entity");
        data?.forEach((x) => {
          me.entities.push({
            id: x.id,
            name: x.info,
          });
        });
      } catch (error) {
        console.log(error);
      } finally {
        me.loading = me.diagnosticId > 0 ? true : false;
      }
    },
    async loadDiagnostic() {
      const me = this;
      me.record = null;
      me.loading = true;
      try {
        const { data } = await detailDiagnostic(me.diagnosticId);
        me.record = data;
      } catch (error) {
        console.log(error);
      } finally {
        me.loading = false;
      }
    },
  },
  async mounted() {
    const me = this;
    const params = me.$route.params.is_edit || null;
    me.isEdit = params && params !== "false" ? false : true;
    await me.loadEntities();
    if (me.diagnosticId > 0) me.loadDiagnostic();
    // if (me.employeeId < 1)
    //   return me.$router.push({ name: "errorPage", params: { code: 400 } });
  },
};
</script>

<style lang="scss">
.alert-danger-form-ipt {
  border: 1px solid #ac0000 !important;
  border-radius: 4px !important;
  background-color: #ffdfdf !important;
  margin-bottom: 40px;
}
.hr-form-ipt {
  border-bottom: 1px solid #c9caff !important;
  margin: 16px 0 !important;
}
.breadcrumb-link {
  color: #5d5fef;
  font-family: "Ubuntu";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  margin-top: 0.125em;
}
</style>
